import { KEYS } from 'app/constants/SceneConstants';
import { ControlsGuide } from '../display/ui/ControlsGuide';
import { HeroPreviewer } from '../display/ui/HeroPreviewer';
import { ItemSelectButton } from '../input/ItemSelectButton';
import SceneBaseTT from './SceneBaseTT';

export default class CharacterSelect extends SceneBaseTT {
  constructor() {
    super({ key: KEYS.CharacterSelect, active: false });
  }

  create() {
    super.create();
    this.setBackgroundImage('background_blue');
    this.game.hud.setState('CHARACTER_SELECT');

    const heroes = this.game.model.getHeroes();
    heroes.sort((a, b) => a.cost - b.cost);
    this._characterButtons = heroes.map((hero, index) => {
      const x = 475 + 180 * index;
      const y = 512;

      const locked = !this.game.player.hasUnlockedHero(hero.id);

      const btn = new ItemSelectButton(this, {
        x,
        y,
        id: hero.id,
        locked,
        cost: locked ? hero.cost : 0,
        label: 'character_name_' + hero.id,
      });
      btn.on('click', this.handleCharcterSelect, this);
      return btn;
    });

    this._selectedFrame = this.add
      .image(0, 0, 'graphics', 'item_select_frame_over')
      .setOrigin(0.5, 1)
      .setVisible(false);
    this._selectedName = this.add.image(0, 0, 'locale_text', '').setVisible(false);
    this._selectedAnim = this.add.spine(0, 0, 'fire', 'animation', true).setVisible(false);

    this.game.hud.events.on('btn_back', this.game.showWelcome, this.game);
    this.game.hud.events.on('btn_continue', this.handleContinue, this);
    this.game.hud.events.on('btn_newgame', this.handleNewGame, this);

    this.game.soundController.playMusic('character_select');
  }

  handleCharcterSelect(btn) {
    if (!this.game.player.hasUnlockedHero(btn.id)) {
      if (this.game.model.canPurchaseHero(btn.id, this.game.player.coins)) {
        return this.game.sceneController.showOverlayScene(KEYS.ConfirmAction, {
          data: {
            type: 'unlock',
            price: this.game.model.getHeroConfig(btn.id).cost,
            onConfirm: () => {
              this.purchaseCharacter(btn.id);
              this.handleCharcterSelect(btn);
            },
            onConfirmScope: this,
          },
        });
      } else {
        return this.game.sceneController.showOverlayScene(KEYS.ConfirmAction, {
          data: {
            type: 'nomoney',
            price: this.game.model.getHeroConfig(btn.id).cost,
          },
        });
      }
    }

    if (!this._selectedCharacter) {
      const hud = this.game.player.hasStoryProgress()
        ? 'CHARACTER_SELECT_PROGRESS_PLUS'
        : 'CHARACTER_SELECT_PROGRESS';
      this.game.hud.setState(hud);
    }
    this._selectedCharacter = btn.id;
    this.game.player.setActiveHero(this._selectedCharacter);
    this.showControls();

    if (this._heroPreview) this._heroPreview.destroy();
    this._heroPreview = new HeroPreviewer(this, btn.id);
    this._heroPreview.x = btn.x;
    this._heroPreview.y = btn.y;

    this._selectedFrame.x = btn.x;
    this._selectedFrame.y = btn.y;

    this._selectedFrame.visible = true;

    this._selectedName.x = btn.x + 10;
    this._selectedName.y = btn.y - btn.panel.height;
    this._selectedName.visible = true;
    this._selectedName.setFrame('character_name_' + btn.id);
    this._selectedAnim.x = this._selectedName.x;
    this._selectedAnim.y = this._selectedName.y;
    this._selectedAnim.visible = true;
    this.children.bringToTop(this._selectedAnim);
    this.children.bringToTop(this._selectedFrame);
    this.children.bringToTop(this._selectedName);

    this._characterDemoTimer = 0;
    this._characterDemoIndex = 0;
    this._characterDemoQueue = ['walk', 'idle', 'jump', 'attack', 'special', 'pickup'];
  }

  update(time, delta) {
    this._characterDemoTimer -= delta;
    if (this._characterDemoTimer <= 0 && this._heroPreview) {
      this.triggerNextDemo();
      this._characterDemoTimer = 2000;
    }

    if (this._controls && this._controls.state !== this._heroPreview.state) {
      this._controls.setState(this._heroPreview.state);
    }
  }

  triggerNextDemo() {
    const action =
      this._characterDemoQueue[this._characterDemoIndex % this._characterDemoQueue.length];
    this._characterDemoIndex++;
    this._heroPreview.tiggerDemo(action);

    this._controls.setState(this._heroPreview.state);
  }

  purchaseCharacter(characterid) {
    const hero = this.game.model.getHeroConfig(characterid);
    this.game.player.adjustCoins(-hero.cost);
    this.game.player.unlockHero(hero.id);
    const btn = this._characterButtons.find((b) => b.id === characterid);
    btn.unlock();
  }

  showControls() {
    if (this._controls) return;
    this._controls = new ControlsGuide(this, !this.game.isDesktop);
    this._controls.x = this.game.viewportController.leftPadded;
    this._controls.y = 530;
  }

  handleContinue() {
    this.game.player.hasStoryProgress()
      ? this.game.resumeSavedStoryGame()
      : this.game.startNewStoryGame();
  }

  handleNewGame() {
    this.game.startNewStoryGame();
  }

  shutdown() {
    this._controls = null;
    this._heroPreview = null;
    this._selectedCharacter = null;
    this.game.hud.events.off('btn_back', this.game.showWelcome, this.game);
    this.game.hud.events.off('btn_continue', this.handleContinue, this);
    this.game.hud.events.off('btn_newgame', this.handleNewGame, this);
    super.shutdown();
  }
}
